export const NAME = 'cp:login'

export default function createEvent() {
    return new CustomEvent(NAME, {
        bubbles: true,
        composed: true,
    })
}
